import { useCallback, useEffect, useState } from 'react';

export function useBodyBottomPadding() {
  const [bottom, setBottom] = useState(0);

  const handleSetBottomPadding = useCallback(
    (padding: number) => {
      setBottom(padding);
    },
    [setBottom]
  );

  useEffect(() => {
    document.body.style.paddingBottom = `${bottom}px`;

    return () => {
      document.body.style.paddingBottom = `0`;
    };
  }, [bottom]);

  return { setBodyBottomPadding: handleSetBottomPadding };
}
